export default "__VITE_ASSET__BqrU_lxA__"